<template>
  <component :is="component" />
</template>

<script>
import clientCheck from '../components/clientCheck.vue'
import clientEdit from '../clientEdit.vue'
export default {
  components: {
    clientCheck,
    clientEdit
  },
  data() {
    return {
      component: 'clientCheck'
    }
  },
  created() {
    const { _role } = this.$route.query
    this.component = _role === 'check' ? 'clientCheck' : 'clientEdit'
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/client-manage/check/clientCheck.vue